export default __webpack_public_path__ + "static/media/CarGo_Homepage_Flash_02_LHS.03860172.png";